$('.js-drawer-menu').click(function() {

  $('body').toggleClass('js-scroll-disabled');
  $('#js-drawer-menu').toggleClass('js-active');
  $(this).toggleClass('js-active');

});
